import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom'

function resetFontSize() {
  let width = document.documentElement.clientWidth
  document.documentElement.style.fontSize = `${width / 1920 * 37.5}px`;
}
resetFontSize()
window.addEventListener('resize', e=>setTimeout(resetFontSize,300), false);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HashRouter>
      <App/>
    </HashRouter>
);

